/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

(function ContractsOrderChangeInCarousel() {
    /**
     * handles the visibility of the contractsOrderChangeInCarousel
     *
     * @constructor
     */
    function contractsOrderChangeInCarousel(domCollection) {
        /**
         * // local object availability
         * @type {contractsOrderChangeInCarousel}
         * @private
         */
        var _this = this;


        /**
         * @type {boolean}
         */
        this.mobileOrderIsSet = false;


        /**
         * @type {array of elements}
         */
        this.domCollection = domCollection;


        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.checkIfMobileOrderIsSet();
            _this.changeMobileOrder();
        };


        /**
         * @method checkIfMobileOrderIsSet
         * @returns {undefined}
         */
        this.checkIfMobileOrderIsSet = function () {
            for (var i = 0; i < _this.domCollection.length; i++) {

                if (_this.domCollection[i].classList.contains('has-set-mobile-order')) {
                    _this.mobileOrderIsSet = true;
                }

            }
        };


        /**
         * @method checkIfMobileOrderIsSet
         * @returns {undefined}
         */
        this.changeMobileOrder = function () {
            if (_this.mobileOrderIsSet) {
                for (var i = 0; i < _this.domCollection.length; i++) {

                    var mobileOrder = _this.domCollection[i].dataset.mobileOrder;

                    // Check if the parentNode is '.glide__slide' item
                    if (_this.domCollection[i].parentNode.classList.contains('glide__slide')) {
                        var glideSlide = _this.domCollection[i].parentNode;
                        glideSlide.style.order = mobileOrder;
                        glideSlide.classList.add('js__mobile-order-changed')
                    }
                }
            }
        };


        /**
         * initialize call
         */
        this.init();
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.contractsOrderChangeInCarousel = contractsOrderChangeInCarousel;
})();


$(function(){
		var contracts = document.querySelectorAll('.contract');
		if (contracts) {
				new window.Jumpers.contractsOrderChangeInCarousel(contracts);
		}
});
